export interface IEmojiDefinition {
  readonly tag: `EMOJI_${string}`;
  readonly emoji: string;
}

export const Emoji = {
  WarningYellow: {
    tag: "EMOJI_WARNING_YELLOW",
    emoji: "⚠️",
  },
  SuccessGreen: {
    tag: "EMOJI_SUCCESS_GREEN",
    emoji: "✅",
  },
  ErrorRed: {
    tag: "EMOJI_ERROR_RED",
    emoji: "❌",
  },
  InfoBlue: {
    tag: "EMOJI_INFO_BLUE",
    emoji: "ℹ️",
  },
  CheckMark: {
    tag: "EMOJI_CHECK_MARK",
    emoji: "✓",
  },
  NotEqual: {
    tag: "EMOJI_NOT_EQUAL",
    emoji: "≠",
  },
  Fire: {
    tag: "EMOJI_FIRE",
    emoji: "🔥",
  },
  Rocket: {
    tag: "EMOJI_ROCKET",
    emoji: "🚀",
  },
  Lightning: {
    tag: "EMOJI_LIGHTNING",
    emoji: "⚡",
  },
  Repeat: {
    tag: "EMOJI_REPEAT",
    emoji: "🔄",
  },
  Memo: {
    tag: "EMOJI_MEMO",
    emoji: "📝",
  },
  Magnifier: {
    tag: "EMOJI_MAGNIFIER",
    emoji: "🔎",
  },
  Sparkles: {
    tag: "EMOJI_SPARKLES",
    emoji: "✨",
  },
  ExclamationRed: {
    tag: "EMOJI_EXCLAMATION_RED",
    emoji: "❗",
  },
  FinishFlag: {
    tag: "EMOJI_FINISH_FLAG",
    emoji: "🏁",
  },
  Clipboard: {
    tag: "EMOJI_CLIPBOARD",
    emoji: "📋",
  },
  Gear: {
    tag: "EMOJI_GEAR",
    emoji: "⚙️",
  },
  NoEntry: {
    tag: "EMOJI_NO_ENTRY",
    emoji: "🚫",
  },
  AlarmClock: {
    tag: "EMOJI_ALARM_CLOCK",
    emoji: "⏰",
  },
  GemStone: {
    tag: "EMOJI_GEM_STONE",
    emoji: "💎",
  },
  ArrowRight: {
    tag: "EMOJI_ARROW_RIGHT",
    emoji: "→",
  },
  Building: {
    tag: "EMOJI_BUILDING",
    emoji: "🏢",
  },
  Compass: {
    tag: "EMOJI_COMPASS",
    emoji: "🧭",
  },
  Pin: {
    tag: "EMOJI_PIN",
    emoji: "📍",
  },
  Label: {
    tag: "EMOJI_LABEL",
    emoji: "🏷️",
  },
  FreezeSnowflake: {
    tag: "EMOJI_FREEZE_SNOWFLAKE",
    emoji: "❄️",
  },
  Shield: {
    tag: "EMOJI_SHIELD",
    emoji: "🛡️",
  },
  HourglassFlowing: {
    tag: "EMOJI_HOURGLASS_FLOWING",
    emoji: "⏳",
  },
  Target: {
    tag: "EMOJI_TARGET",
    emoji: "🎯",
  },
  ChartIncreasing: {
    tag: "EMOJI_CHART_INCREASING",
    emoji: "📈",
  },
  Bell: {
    tag: "EMOJI_BELL",
    emoji: "🔔",
  },
  Locked: {
    tag: "EMOJI_LOCKED",
    emoji: "🔒",
  },
  Star: {
    tag: "EMOJI_STAR",
    emoji: "⭐",
  },
  ThumbsUp: {
    tag: "EMOJI_THUMBS_UP",
    emoji: "👍",
  },
  ThumbsDown: {
    tag: "EMOJI_THUMBS_DOWN",
    emoji: "👎",
  },
  PartyPopper: {
    tag: "EMOJI_PARTY_POPPER",
    emoji: "🎉",
  },
  Trophy: {
    tag: "EMOJI_TROPHY",
    emoji: "🏆",
  },
  Brain: {
    tag: "EMOJI_BRAIN",
    emoji: "🧠",
  },
  Puzzle: {
    tag: "EMOJI_PUZZLE",
    emoji: "🧩",
  },
  Link: {
    tag: "EMOJI_LINK",
    emoji: "🔗",
  },
  Bus: {
    tag: "EMOJI_BUS",
    emoji: "🚌",
  },
  Car: {
    tag: "EMOJI_CAR",
    emoji: "🚗",
  },
  Train: {
    tag: "EMOJI_TRAIN",
    emoji: "🚆",
  },
  Map: {
    tag: "EMOJI_MAP",
    emoji: "🗺️",
  },
  Globe: {
    tag: "EMOJI_GLOBE",
    emoji: "🌍",
  },
  Stopwatch: {
    tag: "EMOJI_STOPWATCH",
    emoji: "⏱️",
  },
  Calendar: {
    tag: "EMOJI_CALENDAR",
    emoji: "📅",
  },
  Key: {
    tag: "EMOJI_KEY",
    emoji: "🔑",
  },
  Unlock: {
    tag: "EMOJI_UNLOCK",
    emoji: "🔓",
  },
  Wrench: {
    tag: "EMOJI_WRENCH",
    emoji: "🔧",
  },
  Toolbox: {
    tag: "EMOJI_TOOLBOX",
    emoji: "🧰",
  },
  Package: {
    tag: "EMOJI_PACKAGE",
    emoji: "📦",
  },
  Bulb: {
    tag: "EMOJI_BULB",
    emoji: "💡",
  },
  MoneyBag: {
    tag: "EMOJI_MONEY_BAG",
    emoji: "💰",
  },
  Scales: {
    tag: "EMOJI_SCALES",
    emoji: "⚖️",
  },
  Handshake: {
    tag: "EMOJI_HANDSHAKE",
    emoji: "🤝",
  },
  Eyes: {
    tag: "EMOJI_EYES",
    emoji: "👀",
  },
  Trash: {
    tag: "EMOJI_TRASH",
    emoji: "🗑️",
  },
  Recycle: {
    tag: "EMOJI_RECYCLE",
    emoji: "♻️",
  },
  Rainbow: {
    tag: "EMOJI_RAINBOW",
    emoji: "🌈",
  },
  Boom: {
    tag: "EMOJI_BOOM",
    emoji: "💥",
  },
  SpeechBubble: {
    tag: "EMOJI_SPEECH_BUBBLE",
    emoji: "💬",
  },
  Dollar: {
    tag: "EMOJI_DOLLAR",
    emoji: "💵",
  },
  CreditCard: {
    tag: "EMOJI_CREDIT_CARD",
    emoji: "💳",
  },
  Coin: {
    tag: "EMOJI_COIN",
    emoji: "🪙",
  },
  Bank: {
    tag: "EMOJI_BANK",
    emoji: "🏦",
  },
  Receipt: {
    tag: "EMOJI_RECEIPT",
    emoji: "🧾",
  },
  ChartDecreasing: {
    tag: "EMOJI_CHART_DECREASING",
    emoji: "📉",
  },
  MoneyWithWings: {
    tag: "EMOJI_MONEY_WITH_WINGS",
    emoji: "💸",
  },
  Briefcase: {
    tag: "EMOJI_BRIEFCASE",
    emoji: "💼",
  },
  Euro: {
    tag: "EMOJI_EURO",
    emoji: "💶",
  },
  ChartBar: {
    tag: "EMOJI_CHART_BAR",
    emoji: "📊",
  },
  Question: {
    tag: "EMOJI_QUESTION",
    emoji: "❓",
  },
  Split: {
    tag: "EMOJI_SPLIT",
    emoji: "✂️",
  },
  Users: {
    tag: "EMOJI_USERS",
    emoji: "👥",
  },
  User: {
    tag: "EMOJI_USER",
    emoji: "👤",
  },
  Outbox: {
    tag: "EMOJI_OUTBOX",
    emoji: "📤",
  },
  Inbox: {
    tag: "EMOJI_INBOX",
    emoji: "📥",
  },
  Crown: {
    tag: "EMOJI_CROWN",
    emoji: "👑",
  },
  WarningStop: {
    tag: "EMOJI_WARNING_STOP",
    emoji: "🛑",
  },
  WarningCaution: {
    tag: "EMOJI_WARNING_CAUTION",
    emoji: "🚸",
  },
  WarningProhibited: {
    tag: "EMOJI_WARNING_PROHIBITED",
    emoji: "🚷",
  },
  WarningCross: {
    tag: "EMOJI_WARNING_CROSS",
    emoji: "❎",
  },
  WarningDouble: {
    tag: "EMOJI_WARNING_DOUBLE",
    emoji: "‼️",
  },
  WarningSkull: {
    tag: "EMOJI_WARNING_SKULL",
    emoji: "💀",
  },
  WarningSiren: {
    tag: "EMOJI_WARNING_SIREN",
    emoji: "🚨",
  },
  WarningRadiation: {
    tag: "EMOJI_WARNING_RADIATION",
    emoji: "☢️",
  },
  WarningOrange: {
    tag: "EMOJI_WARNING_ORANGE",
    emoji: "🟠",
  },
  WarningTriangle: {
    tag: "EMOJI_WARNING_TRIANGLE",
    emoji: "🔺",
  },
  Grinning: {
    tag: "EMOJI_GRINNING",
    emoji: "😀",
  },
  Smiling: {
    tag: "EMOJI_SMILING",
    emoji: "😊",
  },
  Laughing: {
    tag: "EMOJI_LAUGHING",
    emoji: "😂",
  },
  HeartEyes: {
    tag: "EMOJI_HEART_EYES",
    emoji: "😍",
  },
  Sad: {
    tag: "EMOJI_SAD",
    emoji: "😢",
  },
  Crying: {
    tag: "EMOJI_CRYING",
    emoji: "😭",
  },
  Disappointed: {
    tag: "EMOJI_DISAPPOINTED",
    emoji: "😞",
  },
  Angry: {
    tag: "EMOJI_ANGRY",
    emoji: "😠",
  },
  Fearful: {
    tag: "EMOJI_FEARFUL",
    emoji: "😨",
  },
  Worried: {
    tag: "EMOJI_WORRIED",
    emoji: "😟",
  },
  Thinking: {
    tag: "EMOJI_THINKING",
    emoji: "🤔",
  },
  Relieved: {
    tag: "EMOJI_RELIEVED",
    emoji: "😌",
  },
  Sleeping: {
    tag: "EMOJI_SLEEPING",
    emoji: "😴",
  },
  Neutral: {
    tag: "EMOJI_NEUTRAL",
    emoji: "😐",
  },
  Surprised: {
    tag: "EMOJI_SURPRISED",
    emoji: "😲",
  },
  Confused: {
    tag: "EMOJI_CONFUSED",
    emoji: "😕",
  },
  SweatSmile: {
    tag: "EMOJI_SWEAT_SMILE",
    emoji: "😅",
  },
  ExplodingHead: {
    tag: "EMOJI_EXPLODING_HEAD",
    emoji: "🤯",
  },
  Woozy: {
    tag: "EMOJI_WOOZY",
    emoji: "🥴",
  },
  Pleading: {
    tag: "EMOJI_PLEADING",
    emoji: "🥺",
  },
  PersonStanding: {
    tag: "EMOJI_PERSON_STANDING",
    emoji: "🧍",
  },
  PersonWalking: {
    tag: "EMOJI_PERSON_WALKING",
    emoji: "🚶",
  },
  PersonRunning: {
    tag: "EMOJI_PERSON_RUNNING",
    emoji: "🏃",
  },
  ManDancing: {
    tag: "EMOJI_MAN_DANCING",
    emoji: "🕺",
  },
  WomanDancing: {
    tag: "EMOJI_WOMAN_DANCING",
    emoji: "💃",
  },
  ManBust: {
    tag: "EMOJI_MAN_BUST",
    emoji: "👨",
  },
  WomanBust: {
    tag: "EMOJI_WOMAN_BUST",
    emoji: "👩",
  },
  ProblemBiohazard: {
    tag: "EMOJI_PROBLEM_BIOHAZARD",
    emoji: "☣️",
  },
  ProblemToxic: {
    tag: "EMOJI_PROBLEM_TOXIC",
    emoji: "☠️",
  },
  ProblemBomb: {
    tag: "EMOJI_PROBLEM_BOMB",
    emoji: "💣",
  },
  ProblemVirus: {
    tag: "EMOJI_PROBLEM_VIRUS",
    emoji: "🦠",
  },
  ProblemPitfall: {
    tag: "EMOJI_PROBLEM_PITFALL",
    emoji: "🕳️",
  },
  ProblemVolcano: {
    tag: "EMOJI_PROBLEM_VOLCANO",
    emoji: "🌋",
  },
  ProblemNoEntrySign: {
    tag: "EMOJI_PROBLEM_NO_ENTRY_SIGN",
    emoji: "⛔",
  },
} as const satisfies Record<string, IEmojiDefinition>;

export type EmojiKey = keyof typeof Emoji;
export type EmojiValue = (typeof Emoji)[EmojiKey];
export type EmojiTag = EmojiValue["tag"];

/** Pin marker for the current ride station in passenger tooltip */
export const CURRENT_STATION_EMOJI = Emoji.Pin.emoji;

/** Marker when a passenger card station matches the opposite ride endpoint */
export const PASSENGER_STATION_MATCHES_OPPOSITE_RIDE_STATION_EMOJI =
  Emoji.CheckMark.emoji;

/** Subtle marker when passenger site differs from ride site */
export const PASSENGER_RIDE_SITE_MISMATCH_EMOJI = Emoji.NotEqual.emoji;

/** Marker when passenger unit/site is outside the user's ride profile scope */
export const PASSENGER_LIMITED_PERMISSIONS_EMOJI = Emoji.WarningYellow.emoji;

/** No-entry marker for inactive passenger in tooltip */
export const INACTIVE_EMOJI = Emoji.NoEntry.emoji;
